import { useMutation, useQueryClient } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function useZoneEdit() {
  const axiosPrivate = useAxiosPrivate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ zoneSerialNumber, data }) => {
      return axiosPrivate({
        method: "PATCH",
        url: `Zone/Edit/${zoneSerialNumber}`,
        data,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getZonesByPropertyId"]);
    },
  });
}

export default useZoneEdit;
